<template>
  <svg width="18" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M.167 22v-4.19l11-6.809-11-6.809V0l17.77 11L.169 22H.167z" fill="#C7C7C7" />
  </svg>
</template>
